// trackcoprv2/frontend/src/utils/officialCrsCalculations.js
// This module encapsulates the CRS score calculation logic based on the
// official IRCC JavaScript tool located at trackcoprv2/InfraScript/ResearchBase/ircc-crs-tool.js which is the source of truth

// --- Data Structures (Points Tables) ---

// Age Points (q3_age from original script)
// [value, description, points_with_spouse, points_without_spouse]
const agePointsTable = [
  ["A", "17 years of age or less", 0, 0],
  ["B", "18 years of age", 90, 99],
  ["C", "19 years of age", 95, 105],
  ["D", "20 years of age", 100, 110],
  ["E", "21 years of age", 100, 110],
  ["F", "22 years of age", 100, 110],
  ["G", "23 years of age", 100, 110],
  ["H", "24 years of age", 100, 110],
  ["I", "25 years of age", 100, 110],
  ["J", "26 years of age", 100, 110],
  ["K", "27 years of age", 100, 110],
  ["L", "28 years of age", 100, 110],
  ["M", "29 years of age", 100, 110],
  ["N", "30 years of age", 95, 105],
  ["O", "31 years of age", 90, 99],
  ["P", "32 years of age", 85, 94],
  ["Q", "33 years of age", 80, 88],
  ["R", "34 years of age", 75, 83],
  ["S", "35 years of age", 70, 77],
  ["T", "36 years of age", 65, 72],
  ["U", "37 years of age", 60, 66],
  ["V", "38 years of age", 55, 61],
  ["W", "39 years of age", 50, 55],
  ["X", "40 years of age", 45, 50],
  ["Y", "41 years of age", 35, 39],
  ["Z", "42 years of age", 25, 28],
  ["AA", "43 years of age", 15, 17],
  ["AB", "44 years of age", 5, 6],
  ["AC", "45 years of age or more", 0, 0]
];

// Education Points (q4_education from original script)
// [value, description, points_with_spouse, points_without_spouse]
const educationPointsTable = [
  ["A", "None, or less than secondary (high school)", 0, 0],
  ["B", "Secondary diploma (high school graduation)", 28, 30],
  ["C", "One-year program at a university, college, trade or technical school, or other institute", 84, 90],
  ["D", "Two-year program at a university, college, trade or technical school, or other institute", 91, 98],
  ["E", "Bachelor's degree (three or more year program at a university, college, trade or technical school, or other institute)", 112, 120],
  ["F", "Two or more certificates, diplomas or degrees. One must be for a program of three or more years", 119, 128],
  ["G", "Master's degree, or professional degree needed to practice in a licensed profession", 126, 135],
  ["H", "Doctoral level university degree (PhD)", 140, 150]
];

// Language Test Points Mapping (celpip, ielts, pte, tef, tcf from original script)
// Structure: { testName: [ [value, speak_range, listen_range, read_range, write_range, clb, fol_pts_spouse, fol_pts_no_spouse, sol_pts_spouse, sol_pts_no_spouse, spouse_pts], ... ] }
const languageTestPoints = {
  celpip: [
    ["H", "10 - 12", "10 - 12", "10 - 12", "10 - 12", 10, 32, 34, 6, 6, 5],
    ["G", "9", "9", "9", "9", 9, 29, 31, 6, 6, 5],
    ["F", "8", "8", "8", "8", 8, 22, 23, 3, 3, 3],
    ["E", "7", "7", "7", "7", 7, 16, 17, 3, 3, 3],
    ["D", "6", "6", "6", "6", 6, 8, 9, 1, 1, 1],
    ["C", "5", "5", "5", "5", 5, 6, 6, 1, 1, 1],
    ["B", "4", "4", "4", "4", 4, 6, 6, 0, 0, 0],
    ["A", "M, 0 - 3", "M, 0 - 3", "M, 0 - 3", "M, 0 - 3", 0, 0, 0, 0, 0, 0]
  ],
  ielts: [
    ["H", "7.5 – 9.0", "8.5 – 9.0", "8.0 – 9.0", "7.5 – 9.0", 10, 32, 34, 6, 6, 5],
    ["G", "7.0", "8.0", "7.0 - 7.5", "7.0", 9, 29, 31, 6, 6, 5],
    ["F", "6.5", "7.5", "6.5", "6.5", 8, 22, 23, 3, 3, 3],
    ["E", "6.0", "6 .0- 7.0", "6.0", "6.0", 7, 16, 17, 3, 3, 3],
    ["D", "5.5", "5.5", "5.0 - 5.5", "5.5", 6, 8, 9, 1, 1, 1],
    ["C", "5.0", "5.0", "4.0 - 4.5", "5.0", 5, 6, 6, 1, 1, 1],
    ["B", "4.0 - 4.5", "4.5", "3.5", "4.0 - 4.5", 4, 6, 6, 0, 0, 0],
    ["A", "0 - 3.5", "0- 4.0", "0 - 3.0", "0 - 3.5", 0, 0, 0, 0, 0, 0]
  ],
  pte: [
    ["H", "89 - 90", "89 - 90", "88 - 90", "90", 10, 32, 34, 6, 6, 5],
    ["G", "84 - 88", "82 - 88", "78 - 87", "88 - 89", 9, 29, 31, 6, 6, 5],
    ["F", "76 - 83", "71 - 81", "69 - 77", "79 - 87", 8, 22, 23, 3, 3, 3],
    ["E", "68 - 75", "60 - 70", "60 - 68", "69 - 78", 7, 16, 17, 3, 3, 3],
    ["D", "59 - 67", "50 - 59", "51 - 59", "60 - 68", 6, 8, 9, 1, 1, 1],
    ["C", "51 - 58", "39 - 49", "42 - 50", "51 - 59", 5, 6, 6, 1, 1, 1],
    ["B", "42 - 50", "28 - 38", "33 - 41", "41 - 50", 4, 6, 6, 0, 0, 0],
    ["A", "0 - 41", "0- 27", "0 - 32", "0 - 40", 0, 0, 0, 0, 0, 0]
  ],
  tef: [
    ["H", "393-450", "316-360", "263-300", "393-450", 10, 32, 34, 6, 6, 5],
    ["G", "371-392", "298-315", "248-262", "371-392", 9, 29, 31, 6, 6, 5],
    ["F", "349-370", "280-297", "233-247", "349-370", 8, 22, 23, 3, 3, 3],
    ["E", "310-348", "249-279", "207-232", "310-348", 7, 16, 17, 3, 3, 3],
    ["D", "271-309", "217-248", "181-206", "271-309", 6, 8, 9, 1, 1, 1],
    ["C", "226-270", "181-216", "151-180", "226-270", 5, 6, 6, 1, 1, 1],
    ["B", "181-225", "145-180", "121-150", "181-225", 4, 6, 6, 0, 0, 0],
    ["A", "0 - 180", "0 - 144", "0 - 120", "0 - 180", 0, 0, 0, 0, 0, 0]
  ],
  tcf: [
    ["H", "16-20", "549-699", "549-699", "16-20", 10, 32, 34, 6, 6, 5],
    ["G", "14-15", "523-548", "524-548", "14-15", 9, 29, 31, 6, 6, 5],
    ["F", "12-13", "503-522", "499-523", "12-13", 8, 22, 23, 3, 3, 3],
    ["E", "10-11", "458-502", "453-498", "10-11", 7, 16, 17, 3, 3, 3],
    ["D", "7-9", "398-457", "406-452", "7-9", 6, 8, 9, 1, 1, 1],
    ["C", "6", "369-397", "375-405", "6", 5, 6, 6, 1, 1, 1],
    ["B", "4-5", "331-368", "342-374", "4-5", 4, 0, 0, 0, 0, 0], // Note: Original script had 6,6 for FOL points here, seems incorrect based on CLB 4. Setting to 0.
    ["A", "0-3", "0-330", "0-341", "0-3", 0, 0, 0, 0, 0, 0]
  ]
};

// --- Helper Functions ---

/**
 * Finds the points for a given factor based on the selected value and spouse status.
 * @param {string} selectedValue - The value selected by the user (e.g., "A", "B").
 * @param {Array<Array<string|number>>} pointsTable - The table containing points (e.g., agePointsTable).
 * @param {boolean} hasSpouse - Whether the applicant has a spouse accompanying them.
 * @returns {number} - The calculated points for this factor.
 */
const getPointsFromTable = (selectedValue, pointsTable, hasSpouse) => {
  const entry = pointsTable.find(row => row[0] === selectedValue);
  if (!entry) return 0;
  // Index 2: points_with_spouse, Index 3: points_without_spouse
  return parseInt(entry[hasSpouse ? 2 : 3], 10) || 0;
};

/**
 * Calculates language points and CLB levels for a specific test.
 * @param {string} testName - The name of the test (e.g., 'ielts', 'celpip').
 * @param {object} scores - An object with keys 'speaking', 'listening', 'reading', 'writing' and their score values (e.g., "H", "G").
 * @param {boolean} isFirstLanguage - True if this is the first official language, false if second.
 * @param {boolean} hasSpouse - Whether the applicant has a spouse accompanying them.
 * @returns {object} - An object containing { points: number, clb: { speaking: number, listening: number, reading: number, writing: number } }.
 */
const calculateLanguagePoints = (testName, scores, isFirstLanguage, hasSpouse) => {
  const testTable = languageTestPoints[testName.toLowerCase()];
  if (!testTable || !scores) {
    return { points: 0, clb: { speaking: 0, listening: 0, reading: 0, writing: 0 } };
  }

  let totalPoints = 0;
  const clbLevels = { speaking: 0, listening: 0, reading: 0, writing: 0 };

  for (const skill of ['speaking', 'listening', 'reading', 'writing']) {
    const scoreValue = scores[skill];
    const entry = testTable.find(row => row[0] === scoreValue);
    if (entry) {
      const clb = parseInt(entry[5], 10) || 0;
      clbLevels[skill] = clb;

      let pointsIndex;
      if (isFirstLanguage) {
        pointsIndex = hasSpouse ? 6 : 7; // fol_pts_spouse / fol_pts_no_spouse
      } else {
        pointsIndex = hasSpouse ? 8 : 9; // sol_pts_spouse / sol_pts_no_spouse
      }
      totalPoints += parseInt(entry[pointsIndex], 10) || 0;
    }
  }

  // Apply maximum points cap for Second Official Language (SOL)
  if (!isFirstLanguage) {
      const maxSOLPoints = hasSpouse ? 22 : 24; // Based on IRCC website tables (not explicitly in script logic but implied)
      if (totalPoints > maxSOLPoints) {
          totalPoints = maxSOLPoints;
      }
  }


  return { points: totalPoints, clb: clbLevels };
};

/**
 * Calculates points for spouse's language proficiency.
 * @param {string} testName - Spouse's test name.
 * @param {object} scores - Spouse's scores {speaking, listening, reading, writing}.
 * @returns {number} - Points awarded for spouse's language.
 */
const calculateSpouseLanguagePoints = (testName, scores) => {
    const testTable = languageTestPoints[testName.toLowerCase()];
    if (!testTable || !scores) return 0;

    let totalPoints = 0;
    for (const skill of ['speaking', 'listening', 'reading', 'writing']) {
        const scoreValue = scores[skill];
        const entry = testTable.find(row => row[0] === scoreValue);
        if (entry) {
            // Index 10: spouse_pts
            totalPoints += parseInt(entry[10], 10) || 0;
        }
    }
    // Max 20 points for spouse language
    return Math.min(totalPoints, 20);
};


// --- Main Calculation Function ---

/**
 * Calculates the Comprehensive Ranking System (CRS) score based on provided data.
 *
 * @param {object} data - An object containing the applicant's information. Expected properties:
 *   - maritalStatus: string ('Single', 'Married', 'CommonLaw')
 *   - spouseOrPartnerIsPR: boolean | null (null if single)
 *   - spouseOrPartnerWillAccompany: boolean | null (null if single or spouse is PR)
 *   - age: string (Value corresponding to agePointsTable, e.g., "D")
 *   - educationLevel: string (Value corresponding to educationPointsTable, e.g., "E")
 *   - studiedInCanada: boolean
 *   - canadianEducationLevel: string | null (Value like "B", "C" from q4c options if studiedInCanada is true)
 *   - firstLanguageTest: string ('ielts', 'celpip', 'pte', 'tef', 'tcf')
 *   - firstLanguageScores: { speaking: string, listening: string, reading: string, writing: string } (Values like "H", "G")
 *   - hasSecondLanguageTest: boolean
 *   - secondLanguageTest: string | null ('ielts', 'celpip', 'pte', 'tef', 'tcf')
 *   - secondLanguageScores: { speaking: string, listening: string, reading: string, writing: string } | null (Values like "H", "G")
 *   - canadianWorkExperience: string ('A', 'B', 'C', 'D', 'E', 'F' corresponding to 0, 1, 2, 3, 4, 5+ years)
 *   - foreignWorkExperience: string ('A', 'B', 'C', 'D' corresponding to 0, 1-2, 3+ years)
 *   - hasCertificateOfQualification: boolean
 *   - hasValidJobOffer: boolean
 *   - jobOfferNocTeer: string | null ('00', '0123', '45') - Simplified based on original script's q8a options
 *   - hasProvincialNomination: boolean
 *   - hasSiblingInCanada: boolean
 *   - spouseEducationLevel: string | null (Value corresponding to educationPointsTable, e.g., "E")
 *   - spouseCanadianWorkExperience: string | null ('A', 'B', 'C', 'D', 'E', 'F' corresponding to 0, 1, 2, 3, 4, 5+ years)
 *   - spouseLanguageTest: string | null ('ielts', 'celpip', 'pte', 'tef', 'tcf')
 *   - spouseLanguageScores: { speaking: string, listening: string, reading: string, writing: string } | null (Values like "H", "G")
 *
 * @returns {object} - An object containing the detailed score breakdown and the grand total.
 *   - corePoints: { age: number, education: number, firstLanguage: number, secondLanguage: number, canadianWorkExp: number, total: number }
 *   - spousePoints: { education: number, firstLanguage: number, canadianWorkExp: number, total: number }
 *   - skillTransferabilityPoints: { educationLanguage: number, educationCanadianWorkExp: number, foreignWorkExpLanguage: number, foreignWorkExpCanadian: number, certificateQualification: number, total: number }
 *   - bonusPoints: { sibling: number, frenchSkills: number, canadianStudy: number, jobOffer: number, provincialNomination: number, total: number }
 *   - grandTotal: number
 */
export const calculateOfficialCRS = (data) => {
  // Determine if calculating with spouse points
  const isMarriedOrCommonLaw = data.maritalStatus === 'Married' || data.maritalStatus === 'CommonLaw';
  const spouseIsPR = data.spouseOrPartnerIsPR === true;
  const spouseWillAccompany = data.spouseOrPartnerWillAccompany === true;
  const calculateWithSpouse = isMarriedOrCommonLaw && !spouseIsPR && spouseWillAccompany;

  // --- Initialize Scores ---
  const scores = {
    corePoints: { age: 0, education: 0, firstLanguage: 0, secondLanguage: 0, canadianWorkExp: 0, total: 0 },
    spousePoints: { education: 0, firstLanguage: 0, canadianWorkExp: 0, total: 0 },
    skillTransferabilityPoints: { educationLanguage: 0, educationCanadianWorkExp: 0, foreignWorkExpLanguage: 0, foreignWorkExpCanadian: 0, certificateQualification: 0, total: 0 },
    bonusPoints: { sibling: 0, frenchSkills: 0, canadianStudy: 0, jobOffer: 0, provincialNomination: 0, total: 0 },
    grandTotal: 0
  };

  // --- I. Core / Human Capital Factors ---
  scores.corePoints.age = getPointsFromTable(data.age, agePointsTable, calculateWithSpouse);
  scores.corePoints.education = getPointsFromTable(data.educationLevel, educationPointsTable, calculateWithSpouse);

  const folResult = calculateLanguagePoints(data.firstLanguageTest, data.firstLanguageScores, true, calculateWithSpouse);
  scores.corePoints.firstLanguage = folResult.points;
  const folClb = folResult.clb; // Keep CLB levels for skill transferability

  if (data.hasSecondLanguageTest && data.secondLanguageTest && data.secondLanguageScores) {
    const solResult = calculateLanguagePoints(data.secondLanguageTest, data.secondLanguageScores, false, calculateWithSpouse);
    scores.corePoints.secondLanguage = solResult.points;
  }

  // Canadian Work Experience Points (q6i)
  const canadianWorkExpMap = calculateWithSpouse
    ? { A: 0, B: 35, C: 46, D: 56, E: 63, F: 70 } // With Spouse
    : { A: 0, B: 40, C: 53, D: 64, E: 72, F: 80 }; // Without Spouse
  scores.corePoints.canadianWorkExp = canadianWorkExpMap[data.canadianWorkExperience] || 0;

  scores.corePoints.total = scores.corePoints.age + scores.corePoints.education + scores.corePoints.firstLanguage + scores.corePoints.secondLanguage + scores.corePoints.canadianWorkExp;
  // Max Core points: 500 (without spouse), 460 (with spouse) - Apply cap if needed, though unlikely with component scores
  const maxCore = calculateWithSpouse ? 460 : 500;
  scores.corePoints.total = Math.min(scores.corePoints.total, maxCore);


  // --- II. Spouse Factors ---
  if (calculateWithSpouse) {
    // Spouse Education (q10)
    const spouseEducationMap = { A: 0, B: 2, C: 6, D: 7, E: 8, F: 9, G: 10, H: 10 };
    scores.spousePoints.education = spouseEducationMap[data.spouseEducationLevel] || 0;

    // Spouse Canadian Work Experience (q11)
    const spouseCanadianWorkExpMap = { A: 0, B: 5, C: 7, D: 8, E: 9, F: 10 };
    scores.spousePoints.canadianWorkExp = spouseCanadianWorkExpMap[data.spouseCanadianWorkExperience] || 0;

    // Spouse Language (q12i)
    if (data.spouseLanguageTest && data.spouseLanguageScores) {
        scores.spousePoints.firstLanguage = calculateSpouseLanguagePoints(data.spouseLanguageTest, data.spouseLanguageScores);
    }

    scores.spousePoints.total = scores.spousePoints.education + scores.spousePoints.firstLanguage + scores.spousePoints.canadianWorkExp;
    // Max Spouse points: 40
    scores.spousePoints.total = Math.min(scores.spousePoints.total, 40);
  }


  // --- III. Skill Transferability Factors ---
  const clb7Plus = folClb.speaking >= 7 && folClb.listening >= 7 && folClb.reading >= 7 && folClb.writing >= 7;
  const clb9Plus = folClb.speaking >= 9 && folClb.listening >= 9 && folClb.reading >= 9 && folClb.writing >= 9;
  const hasCanadianWorkExp1Year = data.canadianWorkExperience === 'B';
  const hasCanadianWorkExp2PlusYears = ['C', 'D', 'E', 'F'].includes(data.canadianWorkExperience);
  const hasForeignWorkExp1to2Years = ['B', 'C'].includes(data.foreignWorkExperience); // Original script uses B or C
  const hasForeignWorkExp3PlusYears = data.foreignWorkExperience === 'D';
  const hasPostSecondaryEducation = !['A', 'B'].includes(data.educationLevel);
  const hasHighPostSecondaryEducation = ['F', 'G', 'H'].includes(data.educationLevel); // Two or more, Master's, PhD

  // A. Education + Language (Max 50)
  let educationLanguagePoints = 0;
  if (hasPostSecondaryEducation && clb7Plus) {
      if (hasHighPostSecondaryEducation) {
          educationLanguagePoints = clb9Plus ? 50 : 25;
      } else { // Bachelor's, 1-2 year program
          educationLanguagePoints = clb9Plus ? 25 : 13;
      }
  }
  scores.skillTransferabilityPoints.educationLanguage = educationLanguagePoints;

  // B. Education + Canadian Work Experience (Max 50)
  let educationCanadianWorkExpPoints = 0;
  if (hasPostSecondaryEducation) {
      if (hasHighPostSecondaryEducation) {
          if (hasCanadianWorkExp1Year) educationCanadianWorkExpPoints = 25;
          else if (hasCanadianWorkExp2PlusYears) educationCanadianWorkExpPoints = 50;
      } else { // Bachelor's, 1-2 year program
          if (hasCanadianWorkExp1Year) educationCanadianWorkExpPoints = 13;
          else if (hasCanadianWorkExp2PlusYears) educationCanadianWorkExpPoints = 25;
      }
  }
   scores.skillTransferabilityPoints.educationCanadianWorkExp = educationCanadianWorkExpPoints;

  // C. Foreign Work Experience + Language (Max 50)
  let foreignWorkExpLanguagePoints = 0;
   if (clb7Plus) {
       if (hasForeignWorkExp1to2Years) {
           foreignWorkExpLanguagePoints = clb9Plus ? 25 : 13;
       } else if (hasForeignWorkExp3PlusYears) {
           foreignWorkExpLanguagePoints = clb9Plus ? 50 : 25;
       }
   }
   scores.skillTransferabilityPoints.foreignWorkExpLanguage = foreignWorkExpLanguagePoints;

  // D. Foreign Work Experience + Canadian Work Experience (Max 50)
  let foreignWorkExpCanadianPoints = 0;
   if (hasForeignWorkExp1to2Years) {
       if (hasCanadianWorkExp1Year) foreignWorkExpCanadianPoints = 13;
       else if (hasCanadianWorkExp2PlusYears) foreignWorkExpCanadianPoints = 25;
   } else if (hasForeignWorkExp3PlusYears) {
       if (hasCanadianWorkExp1Year) foreignWorkExpCanadianPoints = 25;
       else if (hasCanadianWorkExp2PlusYears) foreignWorkExpCanadianPoints = 50;
   }
   scores.skillTransferabilityPoints.foreignWorkExpCanadian = foreignWorkExpCanadianPoints;

  // E. Certificate of Qualification + Language (Max 50)
  let certificateQualificationPoints = 0;
  if (data.hasCertificateOfQualification && folClb.speaking >= 5 && folClb.listening >= 5 && folClb.reading >= 5 && folClb.writing >= 5) {
      certificateQualificationPoints = clb7Plus ? 50 : 25;
  }
  scores.skillTransferabilityPoints.certificateQualification = certificateQualificationPoints;

  // Calculate Total Skill Transferability (Max 100)
  // Apply caps for Education (A+B) and Foreign Work Exp (C+D) sub-factors first, as per reference script.
  const educationSubTotal = Math.min(scores.skillTransferabilityPoints.educationLanguage + scores.skillTransferabilityPoints.educationCanadianWorkExp, 50);
  const foreignWorkExpSubTotal = Math.min(scores.skillTransferabilityPoints.foreignWorkExpLanguage + scores.skillTransferabilityPoints.foreignWorkExpCanadian, 50);

  scores.skillTransferabilityPoints.total = Math.min(
      educationSubTotal +
      foreignWorkExpSubTotal +
      scores.skillTransferabilityPoints.certificateQualification,
      100
  );


  // --- IV. Bonus Points --- (Max 600)
  scores.bonusPoints.sibling = data.hasSiblingInCanada ? 15 : 0;

  // French Skills Bonus (Complex logic from original script, simplified based on current IRCC rules)
  // NCLC 7+ in all French skills = 25 points
  // NCLC 7+ in all French skills AND CLB 5+ in all English skills = 50 points
  let frenchBonusPoints = 0;
  let isFrenchFOL = data.firstLanguageTest === 'tef' || data.firstLanguageTest === 'tcf';
  let isFrenchSOL = data.secondLanguageTest === 'tef' || data.secondLanguageTest === 'tcf';
  let frenchClb = isFrenchFOL ? folClb : (isFrenchSOL ? calculateLanguagePoints(data.secondLanguageTest, data.secondLanguageScores, false, calculateWithSpouse).clb : null);
  let englishClb = !isFrenchFOL ? folClb : (data.hasSecondLanguageTest && !isFrenchSOL ? calculateLanguagePoints(data.secondLanguageTest, data.secondLanguageScores, false, calculateWithSpouse).clb : null);

  const nclc7Plus = frenchClb && frenchClb.speaking >= 7 && frenchClb.listening >= 7 && frenchClb.reading >= 7 && frenchClb.writing >= 7;
  const clb5PlusEnglish = englishClb && englishClb.speaking >= 5 && englishClb.listening >= 5 && englishClb.reading >= 5 && englishClb.writing >= 5;

  if (nclc7Plus) {
      frenchBonusPoints = clb5PlusEnglish ? 50 : 25;
  }
  scores.bonusPoints.frenchSkills = frenchBonusPoints;


  // Canadian Study Bonus
  let studyBonusPoints = 0;
  if (data.studiedInCanada && data.canadianEducationLevel) {
      if (data.canadianEducationLevel === 'B') studyBonusPoints = 15; // 1-2 year program
      else if (data.canadianEducationLevel === 'C') studyBonusPoints = 30; // 3+ year, Master's, Prof, PhD
  }
  scores.bonusPoints.canadianStudy = studyBonusPoints;

  // Job Offer Bonus (Commented out as per reference script ircc-crs-tool.js lines 1507-1510)
  let jobOfferBonusPoints = 0;
  /*
  if (data.hasValidJobOffer && data.jobOfferNocTeer) {
      if (data.jobOfferNocTeer === '00') jobOfferBonusPoints = 200;
      else if (data.jobOfferNocTeer === '0123') jobOfferBonusPoints = 50;
      // TEER 4/5 offers don't get points in standard CRS, might be relevant for specific PNP streams not covered here.
  }
  */
  scores.bonusPoints.jobOffer = jobOfferBonusPoints; // Will be 0


  // Provincial Nomination Bonus
  scores.bonusPoints.provincialNomination = data.hasProvincialNomination ? 600 : 0;

  // Calculate Total Bonus Points (Max 600)
  scores.bonusPoints.total = Math.min(
    scores.bonusPoints.sibling +
    scores.bonusPoints.frenchSkills +
    scores.bonusPoints.canadianStudy +
    scores.bonusPoints.jobOffer +
    scores.bonusPoints.provincialNomination,
    600
  );

  // --- Grand Total ---
  scores.grandTotal = scores.corePoints.total + scores.spousePoints.total + scores.skillTransferabilityPoints.total + scores.bonusPoints.total;

  return scores;
};

// --- Export ---
// Export the main calculator and the data tables needed for form options.
export { agePointsTable, educationPointsTable, languageTestPoints };